// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__crEHU","summary":"styles_summary__jIrHF","summaryDetails":"styles_summaryDetails__Iunja","footnote":"styles_footnote__Kw8Dr"};